<template>
    <div>
        <div class="customdim"></div>
        <div class="loader-image">
            <img src="../../assets/weavr_loader.svg" width="100" height="40" alt="loader">
        </div>
        <span class="sr-only">Loading...</span>
    </div>
</template>

<script>
export default {
    name: "Loader",
}
</script>

<style lang="scss">
.loader-image {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 1001;
}

body.modal-open .loader-image {
    z-index: 1045 !important;
}

body.modal-open .customdim {
    z-index: 1044 !important;
}
</style>